import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderService } from '../../../core/providers/services/loader/loader.service';

@Component({
  standalone: true,
  imports: [ CommonModule, MatProgressSpinnerModule ],
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: [ './loader.component.scss' ]
})
export class LoaderSComponent {
  protected loader = inject(LoaderService).loader;
  protected loaderService = inject(LoaderService);

  /** Keep backward compatibility for tests that call setLoaderState */
  protected setLoaderState(state: { loading: boolean; loadingMsg: string | null }) {
    this.loaderService.loader.set(state);
  }
}
